// tslint:disable

import * as React from 'react';
// import {Environment} from "../../environment/environment";
import {MetadataReaderLib} from '../../components/libs/metadata-reader.lib';


export class ELearningTranslations extends React.Component<any, any> {

    public meta = new MetadataReaderLib(null);

    public getElURL () {
        switch (this.meta.env) {
            case 'local':
                return 'http://apidev.e-learning.getpodium.co.uk/';
            case 'dev':
                return 'http://apidev.e-learning.getpodium.co.uk/';
            case 'uat':
                return 'http://apiuat.e-learning.getpodium.co.uk/';
            case 'stg':
                return 'http://apistg.e-learning.getpodium.co.uk/';
            case 'prod':
                return 'http://api.e-learning.getpodium.co.uk/';
            default:
                return 'http://apidev.e-learning.getpodium.co.uk/';
        }
    }


    render() {
        console.log(this.meta)
        return (
            <div className="row">
                <div className="col-xs-12">
                    <iframe src={`${this.getElURL()}admin/languages`} frameBorder="0" width={"100%"} height={"1500px"}></iframe>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/e-learning-translations.tsx